export enum EmployerRoutingEnum {
  Articles = 'articles',
  LocalMission = 'evenement/mission-locale',
  LocalMissionUpdate = 'evenement/mission-locale/:eventId',
}
